import { createRoot } from 'react-dom/client';
import * as React from 'react';
import { useEffect } from 'react';
import { ProductCardViewModel } from '@/features/programs/model/types';
import { BookConsultationCard } from '@/features/programs/shared/ui/BookConsultationCard';
import { VerticalContainer } from '@/components';

type ApTicketOfficeAppProps = {
    cards: ProductCardViewModel[];
};

export function ApTicketOfficeApp(
    containerQuery: string,
    appProps: ApTicketOfficeAppProps,
) {
    const elm = document.querySelector(containerQuery);
    const root = createRoot(elm);
    root.render(<App {...appProps} />);
}

export function App({ cards }: ApTicketOfficeAppProps) {
    useEffect(() => {
        document.getElementById('ap-ticket-office-spinner')?.remove();
    }, []);

    return (
        <VerticalContainer>
            <h1>Overskrift</h1>
            <div>
                beskrivelse beskrivelse beskrivelse beskrivelse beskrivelse
                beskrivelse beskrivelse beskrivelse beskrivelse{' '}
            </div>
            <div className="content-grid">
                {cards.map((card, index) => (
                    <BookConsultationCard
                        productCard={card}
                        className="z-20 mb-8 h-full w-full md:min-h-59 md:max-w-135 lg:max-w-180"
                    />
                ))}
            </div>
        </VerticalContainer>
    );
}
